import React from 'react'
import { IconCard } from '../../elements/IconCard'
import { EyebrowCard } from '../../elements/EyebrowCard'
import { Icon } from 'marketing-site/src/mvp/library/utils'

import { ICardRenderer, IEyebrowCard, IIconCard } from './index'

const CardRenderer = ({ card }: ICardRenderer): React.ReactElement => {
  switch (card.contentType) {
    case 'iconCard':
      const iconCard = card as IIconCard
      iconCard.cta = {
        ...iconCard.cta,
        icon: Icon.Arrow,
      }

      return <IconCard {...iconCard} />
    case 'eyebrowCard':
    default:
      const eyebrowCard = card as IEyebrowCard
      eyebrowCard.cta = {
        ...eyebrowCard.cta,
      }
      return <EyebrowCard {...eyebrowCard} />
  }
}

export default CardRenderer
